export default {
  tag: 'Prueba',
  tag_tooltip: 'Restaurante de prueba: totalmente funcional, nunca facturado.',
  card: {
    title: 'Restaurante de prueba',
    description:
      'Marca un restaurante como tu restaurante de prueba para probar impresión, correos, pedidos e integraciones en producción. Funciona como cualquier otro restaurante y nunca se factura. Los correos y SMS a clientes sobre sus pedidos empiezan con [TEST].',
    payments_note:
      'Los pagos en el restaurante de prueba son reales y se liquidan como cualquier otro. Reembolsa tú mismo los pedidos de prueba. Se nos notifica si sus ventas mensuales superan el umbral de prueba.',
    designated_on: 'Marcado como prueba el {{date}}',
    open_shop: 'Abrir tienda',
    remove: 'Quitar designación de prueba',
    select_placeholder: 'Elige un restaurante',
    mark: 'Marcar como restaurante de prueba',
    no_restaurants: 'Aún no tienes ningún restaurante para marcar.',
    load_error: 'No se pudo cargar tu restaurante de prueba.',
  },
  remove_confirm: {
    title: '¿Quitar la designación de prueba de {{name}}?',
    description_live:
      'La facturación de este restaurante se reanuda y pasa a estar sin conexión de inmediato. Vuelve a lanzarlo desde Configuración de pedidos → Métodos de pedido → Pedidos en vivo, donde eliges su plan.',
    description_stays_live:
      'Este restaurante permanece activo y a partir de ahora vuelve a ser tratado como tus demás restaurantes.',
    description_offline:
      'La facturación de este restaurante se reanuda cuando se active. Su plan se elige al lanzarlo.',
    confirm: 'Quitar designación de prueba',
  },
  toasts: {
    designated: '{{name}} es ahora tu restaurante de prueba. No se factura.',
    designate_error: 'No se pudo marcar el restaurante como de prueba. Inténtalo de nuevo.',
    removed: '{{name}} ya no es tu restaurante de prueba.',
    removed_offline: '{{name}} ya no es tu restaurante de prueba y ahora está sin conexión.',
    remove_error: 'No se pudo quitar la designación de prueba. Inténtalo de nuevo.',
  },
};
